module.exports = __webpack_public_path__ + "media/goforajourney/img/barcelona/img241-bf43be109217e50944da00ec479a08e8.jpg";